import React, { useContext, useState, useEffect, useRef } from "react";
import AppContext from "../../context/store";
import AuthContainer from "../../components/AuthContainer";
import { withRouter } from "react-router-dom";
import { InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "../../theme/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Input from "../../theme/CustomMUI/Input";
import Axios from "axios";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import ValidateLogin from "../../functions/ValidateLogin";
import SmartBanner from "../../components/SmartBanner";
import styled, { css, keyframes } from "styled-components";
import SinglePlan from "../../components/SinglePlan";
import AuthWithToken from "../../functions/AuthWithToken";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import AppQR from "../../assets/images/salonrandevu_qr.png";
import { auth, providerGoogle } from "./Firebase";
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";
import googleIcon from "../../assets/images/googleIcon.png";
import appleIcon from "../../assets/images/appleIcon.png";
import PhoneInput from "react-phone-input-2";
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
const CryptoJS = require("crypto-js");

// Şifrelenmiş credentials için key
const CREDENTIALS_KEY = "SR_AUTO_LOGIN";
const CRYPTO_SECRET = "S@LON_AUTO";

const current_app = process.env.APP_NAME;

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage:
      current_app === "salon"
        ? `url(${require("../../assets/images/unauth_image2.jpg")})`
        : current_app === "en"
          ? `url(${require("../../assets/images/unauth_image_en.jpg")})`
          : `url(${require("../../assets/images/unauth_image3.jpg")})`, // unauth.mockup
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "75%",
  },
  paper: {
    margin: theme.spacing(14, 4, 6),
    display: "flex",
    flexDirection: "column",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0, 5),
  },
}));

const LoginIndex = (props) => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const [countryCode, setCountryCode] = useState('90')
  const [form, setForm] = useState({
    mail: null,
    password: null,
    auths: {
      googleAuth: {
        key: null,
      },
      appleAuth: {
        key: null,
      },
    },
  });

  const [object, setObject] = useState({
    id: 2,
    name: "Ali",
    phone: "054-1234567",
  });

  const [license_ending, setLicenseEnding] = useState({
    modal: false,
    company: null,
  });

  const [rememberMe, setRememberMe] = useState(true);
  const [autoLoginAttempted, setAutoLoginAttempted] = useState(false);
  const adminLoginAttemptedRef = useRef(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    hasLetter: false,
    hasNumber: false,
    hasSpecialChar: false,
    isValid: false
  });

  // Authenticated olunca otomatik redirect
  // ANCAK: Admin giriş route'larında redirect yapma
  useEffect(() => {
    const isAdminLogin =
      props.location.pathname === "/_login" ||
      props.location.pathname === "/admin-login";

    if (isAdminLogin) {
      return; // Admin girişi yapılacak, redirect yapma
    }

    if (context.state.is_authenticated === true && context.state.token) {
      props.history.replace("/dashboard");
    }
  }, [
    context.state.is_authenticated,
    context.state.token,
    props.history,
    props.location.pathname,
  ]);

  // Credentials şifreleme fonksiyonları
  const saveCredentials = (mail, password) => {
    try {
      const credentials = JSON.stringify({ mail, password });
      const encrypted = CryptoJS.AES.encrypt(credentials, CRYPTO_SECRET).toString();
      localStorage.setItem(CREDENTIALS_KEY, encrypted);
    } catch (e) {
      console.error("Credentials kaydetme hatası:", e);
    }
  };

  const getCredentials = () => {
    try {
      const encrypted = localStorage.getItem(CREDENTIALS_KEY);
      if (!encrypted) {
        return null;
      }
      const decrypted = CryptoJS.AES.decrypt(encrypted, CRYPTO_SECRET);

      if (!decrypted || decrypted.sigBytes <= 0) {
        localStorage.removeItem(CREDENTIALS_KEY);
        return null;
      }

      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedString) {
        localStorage.removeItem(CREDENTIALS_KEY);
        return null;
      }

      const parsed = JSON.parse(decryptedString);

      return parsed;
    } catch (e) {
      localStorage.removeItem(CREDENTIALS_KEY);
      return null;
    }
  };

  const clearCredentials = () => {
    localStorage.removeItem(CREDENTIALS_KEY);
  };

  const clearLocalStorage = () => {
    const dashboardOpenTutorial = localStorage.getItem("open_tutorial");
    const savedCredentials = localStorage.getItem(CREDENTIALS_KEY); // Credentials'ı koru
    localStorage.clear();
    if (dashboardOpenTutorial !== null) {
      localStorage.setItem("open_tutorial", "1");
    }
    // Credentials'ı geri yükle (eğer varsa)
    if (savedCredentials) {
      localStorage.setItem(CREDENTIALS_KEY, savedCredentials);
    }
  };

  // Şifre validasyon fonksiyonu
  const validatePassword = (password) => {
    if (!password) {
      setPasswordValidation({
        length: false,
        hasLetter: false,
        hasNumber: false,
        hasSpecialChar: false,
        isValid: false
      })
      return
    }

    const length = password.length >= 6 && password.length <= 12
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasNumber = /[0-9]/.test(password)
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    const isValid = length && hasLetter && hasNumber && hasSpecialChar

    setPasswordValidation({
      length,
      hasLetter,
      hasNumber,
      hasSpecialChar,
      isValid
    })
  };

  // Otomatik giriş için useEffect
  useEffect(() => {
    const isLegacyAdminLogin = props.location.pathname === "/_login";
    const isAdminLogin = props.location.pathname === "/admin-login";

    // Admin girişi için URL parametrelerini önce dene
    // Admin girişi için global flag kontrolünü bypass et
    if (isLegacyAdminLogin || isAdminLogin) {
      if (adminLoginAttemptedRef.current) {
        return;
      }
      adminLoginAttemptedRef.current = true;

      // Admin girişi için flag'i sıfırla - her admin girişinde çalışsın
      delete window.__AUTO_LOGIN_ATTEMPTED__;

      const searchParams = new URLSearchParams(props.location.search);
      const mail = searchParams.get("mail");
      const password = isAdminLogin
        ? searchParams.get("password")
        : "K@rpuz+1V#t";

      if (!mail || !password) {
        toast.error("Admin giriş bilgileri eksik");
        setAutoLoginAttempted(true);
        return;
      }

      // Şifrenin tarayıcı adres çubuğunda görünme süresini mümkün olduğunca kısalt.
      props.history.replace(props.location.pathname);

      // Admin girişi için mevcut oturumu ve localStorage'ı tamamen temizle
      // Bu sayede başka bir hesaba geçiş yapılabilir
      const dashboardOpenTutorial = localStorage.getItem("open_tutorial");
      localStorage.clear();
      sessionStorage.clear();
      if (dashboardOpenTutorial !== null) {
        localStorage.setItem("open_tutorial", "1");
      }

      // Axios header'ını temizle
      if (Axios.defaults.headers.common) {
        delete Axios.defaults.headers.common.Authorization;
      }

      // Context state'ini sıfırla (logout) ve sonra yeni hesapla giriş yap
      context.dispatch({ type: "LOGOUT_USER" }).then(async () => {
        try {
          const response = await Axios.post(`${context.api_endpoint}/auth/staff`, {
            mail,
            password,
          });
          if (response.status === 201) {
            const { data } = response;
            localStorage.setItem("selected_filter_picker", 1);
            await AuthWithToken(data?.data?.token, context);
            props.history.replace("/dashboard");
          }
        } catch (e) {
          console.error("Admin girişi hatası:", e);
          toast.error(e?.response?.data?.message || "Giriş başarısız");
          setAutoLoginAttempted(true);
        }
      });
      return;
    }

    // Global flag kontrolü - tüm sayfa yaşam döngüsünde bir kez (normal giriş için)
    if (window.__AUTO_LOGIN_ATTEMPTED__) {
      return;
    }

    // Kayıtlı credentials varsa otomatik giriş yap
    const credentials = getCredentials();
    if (credentials && credentials.mail && credentials.password) {

      window.__AUTO_LOGIN_ATTEMPTED__ = true;
      (async () => {
        try {
          await LoginFunc(credentials, true);
        } catch (e) {
          // Otomatik giriş başarısız olursa formu doldur
          setForm(prev => ({ ...prev, mail: credentials.mail }));
          setAutoLoginAttempted(true);
        }
      })();
    } else {
      // Eski remember_me_email varsa formu doldur
      const email = localStorage.getItem("remember_me_email");
      if (email) {
        setForm(prev => ({ ...prev, mail: email }));
      }
      setAutoLoginAttempted(true);
    }
    // eslint-disable-next-line
  }, []);

  // sing in with google
  const signInWithGoogle = () => {
    // mail ve password tarayıcıda kayıtlıysa , login yapmadan mail ve passwordu siliyor.
    setForm((prevForm) => ({
      ...prevForm,
      mail: null,
      password: null,
    }));

    signInWithPopup(auth, providerGoogle)
      .then((result) => {
        console.log(result);
        setForm((prevForm) => ({
          ...prevForm,
          auths: {
            ...prevForm.auths,
            googleAuth: {
              ...prevForm.auths.googleAuth,
              key: result.user.uid,
            },
          },
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // sing in with apple
  const singInWithApple = () => {
    // mail ve password tarayıcıda kayıtlıysa , login yapmadan mail ve passwordu siliyor.
    setForm((prevForm) => ({
      ...prevForm,
      mail: null,
      password: null,
    }));
    const provider = new OAuthProvider("apple.com");
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then((result) => {
        console.log(result);
        setForm((prevForm) => ({
          ...prevForm,
          auths: {
            ...prevForm.auths,
            appleAuth: {
              ...prevForm.auths.appleAuth,
              key: result.user.uid,
            },
          },
        }));
      })
      .catch((error) => {
        console.log(error);
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The credential that was used.
        const credential = OAuthProvider.credentialFromError(error);

        // ...
      });
  };

  const validateForm = () => {
    return ValidateLogin(
      [
        {
          field: "E-Posta/Cep Telefonu",
          value: form.mail,
          condition: String,
          required: true,
          type: "email",
        },
        {
          field: "Şifre",
          value: form.password,
          condition: String,
          required: true,
          type: "password",
        },
      ],
      context
    );
  };

  const LoginFunc = async (config, isAutoLogin = false) => {
    if (!(config ?? validateForm())) return;

    try {
      const loginData = config ?? form;
      const response = await Axios.post(`${context.api_endpoint}/auth/staff`, loginData);
      if (response.status === 201) {
        // Önce clearLocalStorage çağır
        clearLocalStorage();
        emailRememberMe();

        // Sonra credentials'ı kaydet (clearLocalStorage'dan SONRA)
        if ((rememberMe || isAutoLogin) && loginData.mail && loginData.password) {
          saveCredentials(loginData.mail, loginData.password);
        }

        // Global flag'i temizle - logout sonrası tekrar otomatik giriş yapılabilsin
        delete window.__AUTO_LOGIN_ATTEMPTED__;

        const { data } = response;

        // Form state'ini temizle
        setForm({
          mail: null,
          password: null,
          auths: {
            googleAuth: { key: null },
            appleAuth: { key: null },
          },
        });

        localStorage.setItem("selected_filter_picker", 1);

        // AuthWithToken çağır - useEffect otomatik redirect yapacak
        await AuthWithToken(data?.data?.token, context);
      } else {
        toast.error(context.t(`login.loginErrorToast`));
        setAutoLoginAttempted(true);
      }
    } catch (e) {
      setAutoLoginAttempted(true);
      if (e.response?.data?.status === 402) {
        setLicenseEnding({
          modal: true,
          company: { ...jwt_decode(e.response.data.data) }.obj.name,
        });
      } else {
        // Otomatik giriş başarısız olursa sessizce hata gösterme
        if (!isAutoLogin) {
          toast.error(e?.response?.data?.message);
        } else {
          clearCredentials();
        }
      }
    }
  };
  useEffect(() => {
    if (
      form.auths.googleAuth.key !== null ||
      form.auths.appleAuth.key !== null
    ) {
      LoginFunc();
      setForm((prevForm) => ({
        ...prevForm,
        mail: null,
        password: null,
        auths: {
          ...prevForm.auths,

          googleAuth: {
            key: null,
          },
          appleAuth: {
            key: null,
          },
        },
      }));
    }
  }, [form.auths]);

  const emailRememberMe = () => {
    rememberMe
      ? localStorage.setItem("remember_me_email", form.mail)
      : localStorage.removeItem("remember_me_email");
  };

  return (
    <AuthContainer>
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={8} className={classes.image} />

        <Grid item xs={12} sm={8} md={4} component={Paper} elevation={6} square>
          <div className={`${classes.paper}`}>
            <Typography
              component="div"
              className="mb-0"
              style={{ textAlign: "center" }}
            >
              {/* <b>{context.app.NAME}</b> */}
              <img
                src={
                  current_app === "salon"
                    ? require("../../assets/images/logo.png")
                    : current_app === "en"
                      ? require("../../assets/images/logo_enrandevu.png")
                      : require("../../assets/images/logo_salonmanagement.png")
                }
                alt=""
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "auto",
                  transform: "translateY(-30px)",
                }}
              />
            </Typography>

            <form
              className={`${classes.form}  pt-4`}
              noValidate
              style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column' }}
              onSubmit={(e) => e.preventDefault()}
            >
              <StyledPhoneInput
                country={'tr'}
                disableDropdown={false}
                enableAreaCodes={false}
                specialLabel=""
                inputClass="hidden-input"
                buttonStyle={{ display: isNaN(form.mail) || form.mail === null || form.mail === '' ? 'none' : 'block', height: '59.33px', backgroundColor: 'white', border: 'none', zIndex: 3 }}
                onChange={(value, country) => setCountryCode(country.dialCode)}
              />
              <StyledInput
                required
                innerInputClassName='my-by'
                isExpanded={isNaN(form.mail) || form.mail === null || form.mail === ''}
                startAdornment={(isNaN(form.mail) || form.mail === null || form.mail === '') ? '' : `+${countryCode}`}
                label={context.t(`login.mailPhoneInputLabel`)}
                value={form.mail ? form.mail : ""}
                onChange={(e) =>
                  setForm({ ...form, mail: e.target.value.split(" ").join("") })
                }
              />



              <Input
                required
                placeholder={context.t(`login.passInputLabel`)}
                label={context.t(`login.passInputLabel`)}
                type={showPassword ? "text" : "password"}
                onFocus={() => setPasswordFocused(true)}
                onBlur={() => setPasswordFocused(false)}
                onChange={(e) => {
                  const newPassword = e.target.value;
                  setForm({ ...form, password: newPassword });
                  validatePassword(newPassword);
                }}
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment>
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {passwordFocused && form.password && (
                <ValidationBox>
                  <ValidationItem isValid={passwordValidation.length}>
                    {passwordValidation.length ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationLength`)}
                  </ValidationItem>
                  <ValidationItem isValid={passwordValidation.hasLetter}>
                    {passwordValidation.hasLetter ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationLetter`)}
                  </ValidationItem>
                  <ValidationItem isValid={passwordValidation.hasNumber}>
                    {passwordValidation.hasNumber ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationNumber`)}
                  </ValidationItem>
                  <ValidationItem isValid={passwordValidation.hasSpecialChar}>
                    {passwordValidation.hasSpecialChar ? <CheckIcon /> : <ClearIcon />} {context.t(`forgotPass.validationSpecialChar`)}
                  </ValidationItem>
                </ValidationBox>
              )}

              {form.password && !passwordValidation.isValid && (
                <PasswordWarningBox>
                  <WarningIcon>⚠️</WarningIcon>
                  <WarningText>
                    <strong>{context.t(`forgotPass.passwordWarning`)}</strong><br />
                    {context.t(`forgotPass.passwordWarningDetails`)}<br />
                  </WarningText>
                </PasswordWarningBox>
              )}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => {
                      setRememberMe(e.target.checked);
                    }}
                    name="checkedRememberMe"
                    color="primary"
                    size="small"
                  />
                }
                label={
                  <span style={{ fontSize: "15px" }}>
                    {process.env.APP_NAME !== "management"
                      ? context.t(`login.rememberMe`)
                      : "Remember Me"}
                  </span>
                }
              />

              <Button
                className="mt-2"
                title={context.t(`login.loginButtonTitle`)}
                type="submit"
                size="lg"
                fullWidth
                textColor="white"
                backgroundColor="primary"
                onClick={() => LoginFunc()}
              />
              <div className="login_btns_wrapper">
                <div
                  onClick={signInWithGoogle}
                  className="google_button_wrapper"
                >
                  <img src={googleIcon} alt="google-icon" />
                  <div>
                    <p>{context.t(`login.loginWithGoogle`)}</p>
                  </div>
                </div>
                <div
                  onClick={singInWithApple}
                  className="google_button_wrapper"
                >
                  <img src={appleIcon} alt="apple-icon" />
                  <div>
                    <p>{context.t(`login.loginwithApple`)}</p>
                  </div>
                </div>
              </div>

              <Button
                className="mt-1"
                title={context.t(`login.registerButtonTitle`)}
                type="submit"
                size="lg"
                fullWidth
                textColor="primary"
                backgroundColor="white"
                onClick={() => {
                  window.location.href =
                    current_app === "salon"
                      ? "http://salonrandevu.com/uye-ol"
                      : current_app === "en"
                        ? "https://enrandevu.com/uye-ol.php"
                        : "https://salonmanagementapp.com/sign-up";
                }}
              />

              <Button
                title={context.t(`login.forgotPassButtonTitle`)}
                type="submit"
                size="lg"
                fullWidth
                textColor="teal"
                backgroundColor="white"
                onClick={() => props.history.push("/forgot-pass")}
              />
            </form>
          </div>
          <SmartBanner />
          <div></div>

          {current_app === "salon" && (
            <QrCode>
              <div>
                <img src={AppQR} alt="QR Code" width="130" height="130" />
              </div>
              <p>{context.t(`login.downloadApp`)}</p>
            </QrCode>
          )}
        </Grid>
      </Grid>

      <LicenseEndingBackdrop className={license_ending.modal ? "show" : "hide"}>
        <LicenseEndingContainer
          className={license_ending.modal ? "show" : "hide"}
        >
          <i
            id="close-button"
            className="material-icons"
            onClick={() =>
              setLicenseEnding({ ...license_ending, modal: false })
            }
          >
            close
          </i>
          <h1>{context.t(`login.license.title`)}</h1>
          <p>
            {context.t(`login.license.description`, {
              company: license_ending.company,
            })}
          </p>
          <Button
            containerStyle={{ flexDirection: "column", height: "auto" }}
            className="mt-2"
            icon="call"
            title={context.t(`login.license.buttonTitle`)}
            backgroundColor="green-opacity"
            textColor="green"
            size="lg"
            onClick={() => window.open("tel:02127060510", "blank")}
          />
          <div className="mt-3">
            <Grid container spacing={4}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                onClick={() => {
                  window.location.href =
                    "https://salonrandevu.com/randevu-takip-programi-fiyatlari";
                }}
              >
                <SinglePlan
                  type={context.t(`login.license.standart.type`)}
                  title={context.t(`login.license.standart.title`)}
                  price="159.00"
                  items={[
                    context.t(`login.license.standart.items[0]`),
                    context.t(`login.license.standart.items[1]`),
                    context.t(`login.license.standart.items[2]`),
                    context.t(`login.license.standart.items[3]`),
                    context.t(`login.license.standart.items[4]`),
                  ]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                onClick={() => {
                  window.location.href =
                    "https://salonrandevu.com/randevu-takip-programi-fiyatlari";
                }}
              >
                <SinglePlan
                  type={context.t(`login.license.premium.type`)}
                  title={context.t(`login.license.premium.title`)}
                  price="269.00"
                  items={[
                    context.t(`login.license.premium.items[0]`),
                    context.t(`login.license.premium.items[1]`),
                    context.t(`login.license.premium.items[2]`),
                    context.t(`login.license.premium.items[3]`),
                    context.t(`login.license.premium.items[4]`),
                  ]}
                />
              </Grid>
            </Grid>
          </div>
        </LicenseEndingContainer>
      </LicenseEndingBackdrop>
    </AuthContainer >
  );
};

export default withRouter(LoginIndex);

const QrCode = styled.div`
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin-top: 3vh;
  }
`;

const StyledPhoneInput = styled(PhoneInput)`
  .form-control {
    display: none !important;
  }
`;

const expandWidth = keyframes`
  from {
      margin-left: 7%;
      width: 93%;
  }
  to {
      margin-left: 0%;
      width: 100%;
  }
`;

const shrinkWidth = keyframes`
  from {
      margin-left: 0%;
      width: 100%;
  }
  to {
     margin-left: 7%;
      width: 93%;
  }
`;

const StyledInput = styled(Input)`
  width: 100%;
  margin-left: 0%;
  z-index: 999;
  display: flex; 
  justify-self: flex-end;
  transition: width 0.3s ease-in-out;
  ${({ isExpanded }) =>
    isExpanded &&
    css`
      animation: ${expandWidth} 0.3s forwards;
    `}

  ${({ isExpanded }) =>
    !isExpanded &&
    css`
      animation: ${shrinkWidth} 0.3s forwards;
    `}
`;

const LicenseEndingBackdrop = styled.div`
  width: 100%;
  height: 100vh;
  padding: 10px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: -100vh;

  background: rgba(0, 0, 0, 0.16);

  visibility: hidden;
  opacity: 0;
  transition: all ease 0.4s;
  backdrop-filter: blur(15px);
  z-index: 9999;

  transition: opacity ease 0.5s, bottom ease 0.25s;

  &.show {
    visibility: visible;
    bottom: 0;
    opacity: 1;
  }
`;

const LicenseEndingContainer = styled.div`
  width: 1000px;
  max-width: 100%;
  max-height: 90vh;
  background: #fff;
  border-radius: 10px;
  padding: 48px;

  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

  overflow-y: auto;

  display: flex;
  flex-direction: column;
  aling-items: center;
  justify-contetn: center;
  text-align: center;

  position: relative;
  opacity: 0;
  bottom: -50vh;

  &.show {
    bottom: 0;
    opacity: 1;
    transition: all ease 0.5s;
  }

  h1 {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    line-height: 1.614;
  }

  i#close-button {
    font-size: 26px;
    padding: 24px;
    color: #000;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

// Animasyonlar
const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(220, 38, 38, 0);
  }
`;

// Şifre Uyarı ve Validasyon Styled Components
const PasswordWarningBox = styled.div`
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
  animation: ${slideDown} 0.5s ease-out, ${pulse} 2s infinite;
  border: 2px solid rgba(255, 255, 255, 0.2);
`;

const WarningIcon = styled.div`
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 2px;
`;

const WarningText = styled.div`
  color: white;
  font-size: 15px;
  line-height: 1.6;
  
  strong {
    font-weight: 600;
    font-size: 16px;
  }
`;

const ValidationBox = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  border: 1px solid #e5e7eb;
`;

const ValidationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  font-size: 14px;
  color: ${props => props.isValid ? '#10b981' : '#ef4444'};
  font-weight: 500;
  transition: all 0.3s ease;
  
  svg {
    width: 18px;
    height: 18px;
  }
`;
